var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scenario",class:_vm.textDir},[_c('h2',[_vm._v(_vm._s(_vm.scenario.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.scenario.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }